var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaxWinFsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.018 8.991C4.238 5.881 6.484 3.5 10 3.5c2.874 0 5.007 1.794 6 4l.5-1.5 1.5.5c-1.317-2.925-4.341-5-8-5-4.706 0-7.762 3.354-7.987 7.507L0 8l3 4 3-4-1.982.991zm11.964 2.018c-.22 3.11-2.466 5.491-5.982 5.491-2.874 0-5.007-1.794-6-4L3.5 14 2 13.5c1.316 2.925 4.341 5 8 5 4.706 0 7.762-3.354 7.987-7.507L20 12l-3-4-3 4 1.982-.991zM10 7l-3 3 3 3 3-3-3-3z",
    fill: "#9A9CAC"
  })));
}

export default SvgMaxWinFsIcon;